import React from 'react';
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";

import * as commonFunc from 'scripts/common';

import {
    Button, Col
} from "reactstrap";


export default function OpenFileFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register } = formManager;


    const [shouldRender, setShouldRender] = React.useState(false);

    React.useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        //TEMP : PB réactualisation bg button
        var backgroundRequired = document.querySelectorAll("[data-backimage]");
        backgroundRequired.forEach((node) => {
            node.style.setProperty("--bg-image", node.getAttributeNode("data-backimage").value);
            node.style.setProperty("--bg-opacity", node.getAttributeNode("data-imageopacity")?.value);
        });

        if ((!data.children || data.children.length === 0) && modelFctManager && modelFctManager.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);



    //value / src from getValues
    //defaultValue
    //+ format

    //Voir pour la consultatino des UPJ etc...


    var onClick = (e) => {
        if (e) e.preventDefault();
        if (!disabled) {
            if (data.onActionEvents && data.onActionEvents["onClick"]) {
                data.onActionEvents["onClick"].forEach((args, index) => {
                    //args.value / args.target
                    modelFctManager.onActionRequired(data.name, args, data, data.argumentsObj, e).then(actionResponse => {
                        //console.debug("RESPONSE");
                        //console.debug(actionResponse);
                        if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: actionResponse.errorMessage
                            });
                        }
                    });
                });
            }
        }
    };

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };
    data.functionManager.performClick = () => { onClick() };

    register(bindPropResult);

    var disabled = ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false));

    var btnClass = "m-1";
    var btnSupClass = "";
    var btnStyle = { overflow: "hidden" };
    var containerStyle = {};
    var frameClass = "";
    var frameStyle = {};
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        switch (data.checkRights.action) {
            case "disabled":
                if (!hasRights) disabled = true;
                break;
            default:
                if (!hasRights) frameClass += " d-none";
                break;
        }
    }
    if (commonFunc.isBlank(data.title) && (data.children == null || data.children.length <= 1)) btnSupClass += " btn-icon ";

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_openFile");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            var supBoxSize = modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
            frameClass += supBoxSize;
            btnClass += supBoxSize;
        }

        if (design.height) btnStyle.height = design.height;
        if (design.width) btnStyle.width = design.width;

        var marginElevation = 0;
        if (design.elevation) {
            btnStyle.boxShadow = design.elevation + " " + design.elevation + " 5px rgba(0,0,0,.15)";
            marginElevation = parseInt(design.elevation.replace("px", ""));
        }

        //btnStyle.margin = design.margin;
        var margin = design.margin ? parseInt(design.margin.replace("px", "")) : -1;
        var marginTop;
        if (design.marginTop) {
            if (design.marginTop.indexOf("px") >= 0) {
                marginTop = parseInt(design.marginTop.replace("px", ""));
            }
            else {
                btnSupClass += design.marginTop;
            }
        }
        else {
            marginTop = margin;
        }
        var marginLeft = design.marginStart ? parseInt(design.marginStart.replace("px", "")) : margin;
        var marginBottom = design.marginBottom ? parseInt(design.marginBottom.replace("px", "")) : margin;
        var marginRight = design.marginEnd ? parseInt(design.marginEnd.replace("px", "")) : margin;

        if (marginLeft !== -1 || marginTop !== -1 || marginRight !== -1 || marginBottom !== -1) {
            if (marginTop !== -1) btnStyle.marginTop = (marginTop + marginElevation) + "px";
            if (marginRight !== -1) btnStyle.marginRight = (marginRight + marginElevation) + "px";
            if (marginBottom !== -1) btnStyle.marginBottom = (marginBottom + marginElevation) + "px";
            if (marginLeft !== -1) btnStyle.marginLeft = (marginLeft + marginElevation) + "px";
        }
        else {
            btnStyle.margin = marginElevation + "px";
        }
        if (design.margin) {
            btnClass = btnClass.replace("m-1", "");
        }

        //alignment / fontSize / fontStyle

        if (design.fontColor) btnStyle.color = modelFctManager.getRgbaFromHex(design.fontColor);
        Object.assign(btnStyle, modelFctManager.setCustomBackground(design, data));
    }

    //designTitle.alignment

    data.childCount = data.children ? data.children.length : 0;
    var childs = data.children?.map((child) => { return modelFctManager.componentTyped(child, { ...parentProps, parentData: data, childs: data.children, parentDisabled: (parentDisabled || data.disabled ? true : false), stopPartition: (parentProps.stopPartition || data.groupSubName?.startsWith("containerGroup")) }); }) || "";

    var configAttr = (isConfiguration ? {} : {});
    var baseForm = <Button color="none" className={`btn-sm ${btnClass} ${btnSupClass} ${data.classSup}`} style={btnStyle} data-backimage={btnStyle.hasImage || null} data-imageopacity={btnStyle.alpha || null}
        disabled={disabled} onClick={onClick} {...configAttr}>
        <div style={containerStyle} data-backimage={containerStyle.hasImage || null} data-imageopacity={containerStyle.alpha || null}>
            {childs}
            {altT(data.title)}
        </div>
    </Button>;
    return <Col data-name="OpenFileFrag" data-element={data.objType} xs="auto" className={` ${frameClass} ${parentProps.parentData.customDesign && parentProps.parentData.customDesign.design && parentProps.parentData.customDesign.design.spacing ? "" : "p-0"}`} style={frameStyle}>{baseForm}</Col>;//align-self-center
}